/*
 *
 * App actions
 *
 */

import {
  CHANGE_CURRENT_PROJECT_START,
  CHANGE_CURRENT_PROJECT_SUCCESS,
  GET_TEAMS_ONLY_TOKEN,
  GET_APP_DETAILS,
  SEND_UPGRADE_MAIL,
} from './constants';
import { defineAction } from 'utils/action-helper';

export const sendUpgradeMail = {
  start: ({ metadata }) => {
    return {
      type: SEND_UPGRADE_MAIL.START,
      metadata,
    };
  },
  success: data => {
    return {
      type: SEND_UPGRADE_MAIL.SUCCESS,
    };
  },
  error: error => {
    return {
      type: SEND_UPGRADE_MAIL.ERROR,
    };
  },
};

export const getAppDetails = {
  start: () => defineAction({ type: GET_APP_DETAILS.START }),
  success: () =>
    defineAction({
      type: GET_APP_DETAILS.SUCCESS,
    }),
  error: error =>
    defineAction({
      type: GET_APP_DETAILS.ERROR,
      payload: { error },
    }),
};

export const getTeamsOnlyToken = {
  start: ({ metadata }) => defineAction({ type: GET_TEAMS_ONLY_TOKEN.START, metadata }),
  success: ({ data }) =>
    defineAction({
      type: GET_TEAMS_ONLY_TOKEN.SUCCESS,
      payload: { data },
    }),
  error: error =>
    defineAction({
      type: GET_TEAMS_ONLY_TOKEN.ERROR,
      payload: { error },
    }),
};

export const changeCurrentProject = ({ payload, metadata }) => {
  return {
    type: CHANGE_CURRENT_PROJECT_START,
    payload,
    metadata,
  };
};

export const changeCurrentProjectSuccess = data => {
  return {
    type: CHANGE_CURRENT_PROJECT_SUCCESS,
    payload: {
      data,
    },
  };
};
